import { useTranslation } from 'react-i18next'

export type ReturnReason =
  | 'WRONG_DELIVERY'
  | 'MISSING_ITEMS'
  | 'DAMAGED_DEFECTIVE'
  | 'NOT_AS_DESCRIBED'
  | 'OTHER'

export function useReturnReasonLabels(): Record<ReturnReason, string> {
  const { t } = useTranslation()

  return {
    WRONG_DELIVERY: t('common.returnReasons.WRONG_DELIVERY'),
    MISSING_ITEMS: t('common.returnReasons.MISSING_ITEMS'),
    DAMAGED_DEFECTIVE: t('common.returnReasons.DAMAGED_DEFECTIVE'),
    NOT_AS_DESCRIBED: t('common.returnReasons.NOT_AS_DESCRIBED'),
    OTHER: t('common.returnReasons.OTHER'),
  }
}
